import { Button, EmptyState, PageHead } from "@nabble/ui";
import { BRAND_SLOTS } from "../../../model/brandSlots";
import { BrandSlotCard } from "./BrandSlotCard";
import { useBrandImages } from "./useBrandImages";
import "./AdminBrandingPage.css";

/** Admin Center → Branding: the brand images, stored in the database and shown across the suite and website. */
export default function AdminBrandingPage(): React.JSX.Element {
  const { images, loadError, busy, reload, upload, remove } = useBrandImages();
  const head = (
    <PageHead
      title="Branding"
      subtitle="Logos and icons shown in the suite, its emails and the public website. Without an image, the suite shows the Nabble_ wordmark."
    />
  );
  if (loadError) {
    return (
      <>
        {head}
        <EmptyState icon="alertCircle" title="We couldn't load the brand images" description={loadError}
          action={<Button label="Try again" variant="secondary" icon="refresh" onClick={reload} />} />
      </>
    );
  }
  return (
    <>
      {head}
      <div className="brand-slots">
        {BRAND_SLOTS.map((slot) => (
          <BrandSlotCard key={slot.key} slot={slot} image={images?.find((i) => i.slot === slot.key)}
            busy={busy === slot.key} onUpload={(file) => upload(slot.key, file)} onRemove={() => remove(slot.key)} />
        ))}
      </div>
    </>
  );
}
